import {
  Button,
  Input,
  InputGroup,
  InputRightElement,
  useClipboard,
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

function Copy({ value }: { value: string }) {
  const { t } = useTranslation('admin');
  const { hasCopied, onCopy } = useClipboard(value);
  return (
    <InputGroup size="md">
      <Input value={value} isReadOnly />
      <InputRightElement width="4.5rem">
        <Button
          variant="outline"
          h="1.75rem"
          size="sm"
          onClick={onCopy}
          bg="#fff"
        >
          {hasCopied ? t('Copied') : t('Copy')}
        </Button>
      </InputRightElement>
    </InputGroup>
  );
}

export default Copy;
